export default __webpack_public_path__ + "static/media/success.0ce960f4.svg";